import { render, staticRenderFns } from "./showCard.vue?vue&type=template&id=133480d2&scoped=true&"
import script from "./showCard.vue?vue&type=script&lang=js&"
export * from "./showCard.vue?vue&type=script&lang=js&"
import style0 from "./showCard.vue?vue&type=style&index=0&id=133480d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133480d2",
  null
  
)

export default component.exports